import React, { useEffect } from 'react';
import DailyFormReport from './reports/dailyForm';
import DailyDateFormReport from './reports/dailyDateForm';
import MonthlyFormReport from './reports/monthlyForm';
import CONFIG from '../../config/env';

const { Title } = CONFIG;

export default ({ title, url, repType, repUrl, isDateRange, FetchComponent, onDataChange, printHeader, printFooter,
    onDateChange, onFilterChange, customExcelExport }) => {

    useEffect(() => {
        document.title = `${Title} (${title})`;
    }, []);

    return repType === 'daily' ? (
        <DailyFormReport
            url={url}
            repType={repUrl || repType}
            title={title}
            isDateRange={isDateRange}
            FetchComponent={FetchComponent}
            printFooterReport={printFooter}
            printHeaderReport={printHeader}
            onDataChange={onDataChange}
            onDateChange={onDateChange}
            onFilterChange={onFilterChange}
            customExcelExport={customExcelExport}
        />
    ) : repType === 'daily_date' ? (
        <DailyDateFormReport
            url={url}
            repType={repUrl || repType}
            title={title}
            isDateRange={isDateRange}
            FetchComponent={FetchComponent}
            printFooterReport={printFooter}
            printHeaderReport={printHeader}
            onDataChange={onDataChange}
            onDateChange={onDateChange}
            onFilterChange={onFilterChange}
            customExcelExport={customExcelExport}
        />
    ) :
        <MonthlyFormReport
            url={url}
            repType={repUrl || repType}
            title={title}
            isDateRange={isDateRange}
            FetchComponent={FetchComponent}
            printFooterReport={printFooter}
            printHeaderReport={printHeader}
            onDataChange={onDataChange}
            onDateChange={onDateChange}
            onFilterChange={onFilterChange}
            customExcelExport={customExcelExport}
        />
}
